import React, { useState, useEffect,useRef  } from "react";
import { styles } from "../styles/AddGroup.styles";
import { IoChevronBackCircle } from "react-icons/io5";
import { MdGroupAdd,MdGroup } from "react-icons/md";
import { getTomadoresContact, getUtilizadoresContact } from "../services/Contacts";
import { getProfile } from "../services/profile";
import { formatFirstLastName,arrayBufferToBase64 } from "../utils/utils";
import { FaUserShield } from "react-icons/fa6";
import { FaUser } from "react-icons/fa";
import { useAuth } from "../context/AuthContext";
import { FaChevronUp, FaChevronDown } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

export default function AddChat({ onClose,isMobile, onNewChat, socket }) {
  const { token, stampTomador } = useAuth(); 
  const [search, setSearch] = useState("");
  const [tomadores, setTomadores] = useState([]);
  const [utilizadores, setUtilizadores] = useState([]);
  const [perfil, setPerfil] = useState({ NOME: "", FOTO: null });
  const [selectedParticipants, setSelectedParticipants] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [groupName, setGroupName] = useState("");
  const [loading,setLoading] = useState(false);
  const [showTomadores, setShowTomadores] = useState(true);
  const [showUtilizadores, setShowUtilizadores] = useState(true);
  const [loadingTomadores, setLoadingTomadores] = useState(false);
  const [loadingUtilizadores, setLoadingUtilizadores] = useState(false);
  const loadingParticipantes = loadingTomadores || loadingUtilizadores;
  const [limit] = useState(20);
  const [beforeUtilizadores, setBeforeUtilizadores] = useState(null);
  const [hasMoreUtilizadores, setHasMoreUtilizadores] = useState(true);
  const [loadingMoreUtilizadores, setLoadingMoreUtilizadores] = useState(false);
  const [beforeTomadores, setBeforeTomadores] = useState(null);
  const [hasMoreTomadores, setHasMoreTomadores] = useState(true);
  const [loadingMoreTomadores, setLoadingMoreTomadores] = useState(false);
  const fetchingTomadoresRef = useRef(false);
  const fetchingUtilizadoresRef = useRef(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (!token) return;

    fetchTomadores(true);
    fetchUtilizadores(true);
    fetchProfile();


  }, [token]);


   useEffect(() => {
        if (!socket) return;

        let participantsHandled = false;

        const handleParticipantsResult = ({ success, error }) => {
            if (participantsHandled) return;

            if (success) {
                participantsHandled = true;
                onClose();
            } else {
                if (error) {
                    participantsHandled = true;
                    console.error("Erro ao adicionar participantes:", error);
                }
            }
        };

        socket.on("participantsResult", handleParticipantsResult);

        return () => {
            socket.off("participantsResult", handleParticipantsResult);
        };
    }, [socket]);



  const fetchProfile = async () => {
    try {
      const data = await getProfile();

      setPerfil({ NOME: data.NOME, FOTO: data.FOTO });
    } catch (err) {
      console.error("Erro ao buscar perfil:", err);
    }
  };

  const fetchTomadores = async (reset = false) => {
      try {
        if (reset) {
          setLoadingTomadores(true);
          setBeforeTomadores(null);
          setHasMoreTomadores(true);
        } else {
          setLoadingMoreTomadores(true);
        }

        const data = await getTomadoresContact(
          limit,
          reset ? null : beforeTomadores,
          search
        );

        const newItems = Array.isArray(data?.tomadores)
          ? data.tomadores
          : [];

        setTomadores((prev) => {
          const merged = reset ? newItems : [...prev, ...newItems];

          return Array.from(
            new Map(merged.map((item) => [item.STAMP, item])).values()
          );
        });

        setHasMoreTomadores(data?.hasMore ?? false);

        if (newItems.length > 0) {
         const last = newItems[newItems.length - 1];

          setBeforeTomadores(
            last ? { stamp: last.STAMP, nome: last.NOME } : null
          );
        }

      } catch (err) {
        console.error("Erro tomadores:", err);
      } finally {
        setLoadingTomadores(false);
        setLoadingMoreTomadores(false);
      }
  };

const fetchUtilizadores = async (reset = false) => {
  try {
    if (reset) {
      setLoadingUtilizadores(true);
      setBeforeUtilizadores(null);
      setHasMoreUtilizadores(true);
    } else {
      setLoadingMoreUtilizadores(true);
    }

   const data = await getUtilizadoresContact(
      limit,
      reset ? null : beforeUtilizadores,
      search
    );

    const newItems = Array.isArray(data?.utilizadores)
      ? data.utilizadores
      : [];

   setUtilizadores((prev) => {
        const merged = reset ? newItems : [...prev, ...newItems];
        const unique = Array.from(
          new Map(merged.map(item => [item.STAMP, item])).values()
        );

        return unique;
    });

    setHasMoreUtilizadores(data?.hasMore ?? false);

    if (newItems.length > 0) {
      const last = newItems[newItems.length - 1];
      setBeforeUtilizadores({
        nome: last.NOME,
        stamp: last.STAMP,
      });
    }

  } catch (err) {
    console.error("Erro utilizadores:", err);
  } finally {
    setLoadingUtilizadores(false);
    setLoadingMoreUtilizadores(false);
  }
};


const handleScrollTomadores = (e) => {
  const el = e.target;

  const reachedBottom =
    el.scrollTop + el.clientHeight >= el.scrollHeight - 20;

  if (!reachedBottom) return;

  if (!hasMoreTomadores) return;

  if (fetchingTomadoresRef.current) return;

  fetchingTomadoresRef.current = true;

  fetchTomadores(false).finally(() => {
    fetchingTomadoresRef.current = false;
  });
};

  const handleScrollUtilizadores = async (e) => {
    const el = e.target;

    const reachedBottom =
      el.scrollTop + el.clientHeight >= el.scrollHeight - 20;

    if (
      reachedBottom &&
      hasMoreUtilizadores &&
      !fetchingUtilizadoresRef.current
    ) {
      fetchingUtilizadoresRef.current = true;

      await fetchUtilizadores(false);

      fetchingUtilizadoresRef.current = false;
    }
  };
  const toggleParticipant = (user, tipo) => {
    setSelectedParticipants((prev) => {
      const exists = prev.find((p) => p.STAMP === user.STAMP);
      if (exists) return prev.filter((p) => p.STAMP !== user.STAMP);
      return [...prev, { ...user, TIPO: tipo }];
    });
  };

  const openGroupModal = () => {
    if (selectedParticipants.length === 0) return alert("Selecione pelo menos um participante");

     if (selectedParticipants.length === 1) {
          const p = selectedParticipants[0];
          const privateChat = {
            STAMP: `TEMP_PRIVATE_${p.STAMP}`,
            TEMP_INDEX : p.STAMP, 
            NOME: formatFirstLastName(p.NOME),
            LOGO: p.FOTO,
            TIPO: "private",
            STAMPUTILIZADOR: p.TIPO === "UTL" ? p.STAMP : null,
            STAMPTOMADOR: p.TIPO === "TM" ? p.STAMP : null,
            PARTICIPANTS: [p],
            IS_TEMP: true,
          };


          onNewChat?.(privateChat); 
          return;
      }

    setModalOpen(true);
  };

  const selectedTomadores = selectedParticipants.filter((p) => p.TIPO === "TM");

  const handleCreateGroup = async () => {
      if (!socket) return alert("Socket não disponível");

      if (selectedParticipants.length > 1 && !selectedTomadores.length && !groupName.trim()) {
        return alert("Defina o nome do grupo");
      }

      setLoading(true);

      try {
        const tomadoresToCreate = selectedTomadores.length
          ? selectedTomadores
          : [null];

        for (const tomador of tomadoresToCreate) {
          const participantes = selectedParticipants
            .filter((participant) => !tomador || participant.TIPO !== "TM" || participant.STAMP === tomador.STAMP)
            .map((participant) => ({
              NOME: participant.NOME,
              STAMP: participant.STAMP,
              TIPO: participant.TIPO,
            }));
          const nomeGrupo = tomador
            ? formatFirstLastName(tomador.NOME)
            : groupName.trim();

          const result = await new Promise((resolve) => {
            socket.once("createChatResult", resolve);
            socket.emit("createChat", {
              nomeGrupo,
              TIPO: tomador ? "private" : "group",
              PARTICIPANTES: participantes,
            });
          });

          if (!result?.success) {
            throw new Error(result?.error || "Erro ao criar grupo");
          }
        }

        setModalOpen(false);
        onClose();
        window.location.reload();
      } catch (error) {
        alert(error.message);
      } finally {
        setLoading(false);
      }
  };

  useEffect(() => {
      if (!token) return;

      setTomadores([]);
      setUtilizadores([]);

      setBeforeTomadores(null);
      setBeforeUtilizadores(null);

      setHasMoreTomadores(true);
      setHasMoreUtilizadores(true);

      fetchTomadores(true);
      fetchUtilizadores(true);

  }, [search]);


  return (
    <div style={{
      ...styles.container,
      width: isMobile ? "200%" : "100%",
    }}>

       {loadingParticipantes && (
          <div style={styles.loadingOverlay}>
            <div style={styles.spinner} />
          </div>
        )}
      <div style={styles.header}>
        <h2 style={styles.h2}>{"Selecionar Participantes"}</h2>
        <button
          onClick={onClose}
          style={{ background: "none", border: "none", cursor: "pointer", display: "flex", padding: 0 }}
        >
          <IoChevronBackCircle size={40} color="rgb(31, 58, 112)" />
        </button>
      </div>

      <div style={styles.searchContainer}>
      <div style={{ position: "relative",  width: "100%" }}>
        <svg
          style={{
            position: "absolute",
            left: 10,
            top: "50%",
            transform: "translateY(-50%)",
            width: 20,
            height: 20,
            fill: "#9ca3af",
          }}
          viewBox="0 0 24 24"
        >
          <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>
        </svg>
        <input
          type="text"
          placeholder="Pesquisar..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          style={{
            ...styles.input,
            paddingLeft: 35, 
          }}
        />
      </div>
    </div>

        <li
          style={styles.li}
          onClick={() => {}}
          onMouseEnter={(e) => (e.currentTarget.style.background = "#f3f4f6")}
          onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
        >
          <div
            style={{
              ...styles.img,
               display: "flex",
               alignItems: "center",
               justifyContent: "center",
               backgroundColor: perfil.FOTO ? "transparent" : "#e5e7eb"
            }}
          >
            {perfil.FOTO && (
              <div style={styles.imgPhoto(true)}>
                <img
                  src={perfil.FOTO}
                  alt={perfil.NOME}
                  style={{ width: "100%", height: "100%", borderRadius: "50%", objectFit: "cover", display: "block" }}
                  onError={(event) => {
                    event.currentTarget.style.display = "none";
                    event.currentTarget.nextElementSibling.style.display = "flex";
                  }}
                />
                <span
                  style={{
                    width: "100%",
                    height: "100%",
                    display: "none",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <FaUser color="#6b7280" />
                </span>
              </div>
            )}
            {!perfil.FOTO && (
              <div
                style={{
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: "#e5e7eb",
                }}
              >
                <FaUser color="#6b7280" />
              </div>
            )}
          </div>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={styles.optionsTitle}>
              {formatFirstLastName(perfil.NOME) + " (Eu)"}
            </div>
          </div>
        </li>


      <div style={{ flex: 1, paddingBottom: "80px" }}> 
        <ul style={styles.ul}>
        
       {tomadores.length > 0 && (
          <li
            style={{
              ...styles.li,
              fontWeight: "bold",
              backgroundColor: "#f9fafb",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              cursor: "pointer",
            }}
            onClick={() => setShowTomadores((prev) => !prev)}
          >
            <span>Tomadores</span>

            {showTomadores ? (
              <FaChevronUp color="#374151" />
            ) : (
              <FaChevronDown color="#374151" />
            )}
          </li>
        )}     

        {showTomadores && (
            <div style={{ maxHeight: 200, overflowY: "auto" }} onScroll={handleScrollTomadores}>
              {tomadores.map((t) => (
                  <li
                    key={t.STAMP}
                    style={{
                      ...styles.li,
                      background: selectedParticipants.find(
                        (p) => p.STAMP === t.STAMP
                      )
                        ? "#dbeafe"
                        : "transparent",
                    }}
                    onClick={() => toggleParticipant(t, "TM")}
                  >
                    <div style={styles.img}>
                      {t.FOTO && (
                        <img
                          src={t.FOTO}
                          alt={t.NOME}
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",   
                            display: "block",
                          }}
                          onError={(event) => {
                            event.currentTarget.style.display = "none";
                            event.currentTarget.nextElementSibling.style.display = "flex";
                          }}
                        />
                      )}
                      <span
                        style={{
                          width: "100%",
                          height: "100%",
                          display: t.FOTO ? "none" : "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <FaUserShield size={18} color="#6b7280" />
                      </span>
                    </div>

                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={styles.optionsTitle}>
                        {formatFirstLastName(t.NOME)}
                      </div>
                    </div>
                  </li>
                ))}

                {loadingMoreTomadores && (
                  <div
                    style={{
                      padding: 10,
                      display: "flex",
                      justifyContent: "center"
                    }}
                  >
                    <div style={styles.spinner} />
                  </div>
                )}
            </div>
          )}
                    
        

        {utilizadores.length > 0 && (
          <li
            style={{
              ...styles.li,
              fontWeight: "bold",
              backgroundColor: "#f9fafb",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              cursor: "pointer",
            }}
            onClick={() => setShowUtilizadores((prev) => !prev)}
          >
            <span>Utilizadores</span>

            {showUtilizadores ? (
              <FaChevronUp color="#374151" />
            ) : (
              <FaChevronDown color="#374151" />
            )}
          </li>
        )}

        {showUtilizadores && (
            <div style={{ maxHeight: 200, overflowY: "auto" }}  onScroll={handleScrollUtilizadores}>
              {utilizadores.map((u) => (
                  <li
                    key={u.STAMP}
                    style={{
                      ...styles.li,
                      background: selectedParticipants.find(
                        (p) => p.STAMP === u.STAMP
                      )
                        ? "#dbeafe"
                        : "transparent",
                    }}
                    onClick={() => toggleParticipant(u, "UTL")}
                  >
                    <div style={styles.img}>
                      {u.FOTO && (
                        <img
                          src={u.FOTO}
                          alt={u.NOME}
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",   
                            display: "block",
                          }}
                          onError={(event) => {
                            event.currentTarget.style.display = "none";
                            event.currentTarget.nextElementSibling.style.display = "flex";
                          }}
                        />
                      )}
                      <span
                        style={{
                          width: "100%",
                          height: "100%",
                          display: u.FOTO ? "none" : "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <FaUser size={18} color="#6b7280" />
                      </span>
                    </div>

                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={styles.optionsTitle}>
                        {formatFirstLastName(u.NOME)}
                      </div>
                    </div>
                  </li>
                ))}

                {loadingMoreUtilizadores && (
                  <div style={{
                    padding: 10,
                    display: "flex",
                    justifyContent: "center"
                  }}>
                    <div style={styles.spinner} />
                  </div>
                )}
            </div>
          )}
        
      </ul>
    </div>     
      {selectedParticipants.length > 0 && !modalOpen && (
        <button
            onClick={openGroupModal}
            style={{
            position: "fixed",
            bottom: 20,
            left: "30%",
            transform: "translateX(-50%)",
            padding: "12px 30px",
            backgroundColor: "rgb(31, 58, 112)",
            color: "#fff",
            border: "none",
            borderRadius: 25,
            cursor: "pointer",
            boxShadow: "0px 4px 6px rgba(0,0,0,0.2)",
            zIndex: 1000,
            fontWeight: "bold",
            fontSize: 16,
            }}
        >
            Continuar ({selectedParticipants.length})
        </button>
        )}

      {modalOpen && (
        <div style={{
          position: "fixed", top: 0, left: 0, right: 0, bottom: 0,
          backgroundColor: "rgba(0,0,0,0.5)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 2000
        }}>

         <div style={ {background: "#fff", padding: 20, borderRadius: 8, width: 420, maxWidth: "90%", display: "flex", flexDirection: "column", alignItems: "center",position: "relative"}}>
            <button onClick={onClose} style={styles.closeButton}>✕</button>
              <div style={styles.groupPlaceholder}>
                {selectedTomadores.length === 1 && selectedTomadores[0].FOTO ? (
                  <img
                    src={selectedTomadores[0].FOTO}
                    alt={selectedTomadores[0].NOME}
                    style={{ width: "100%", height: "100%", objectFit: "cover" }}
                  />
                ) : (
                  <FaUserShield size={50} color="#666" />
                )}
              </div>

              <h3>
                {selectedTomadores.length === 1
                  ? selectedTomadores[0].NOME
                  : selectedTomadores.length > 1
                    ? `${selectedTomadores.length} Tomadores`
                    : "Novo Grupo"}
              </h3>
        
            <h2 style={styles.groupTitle}></h2>

            <div style={{display:"flex", flexWrap:"wrap"}}> 
                {selectedParticipants.length > 1 && selectedTomadores.length === 0 && (
                  <>
                    <h3>Nome do Grupo</h3>
                    <input
                      type="text"
                       id="group-name"
                       name="groupName"
                      value={groupName}
                      placeholder="Nome do grupo..."
                      onChange={(e) => setGroupName(e.target.value)}
                      style={{ width: "100%", padding: 8, marginBottom: 10 }}
                    />
                  </>
                )}

                <>
                <style>
                    {`
                    @keyframes spin {
                        0% { transform: rotate(0deg); }
                        100% { transform: rotate(360deg); }
                    }
                    .spinner {
                        width: 20px;
                        height: 20px;
                        border: 3px solid #fff;
                        border-top: 3px solid transparent;
                        border-radius: 50%;
                        animation: spin 1s linear infinite;
                    }
                    `}
                </style>

                <button
                onClick={handleCreateGroup}
                disabled={loading}
                style={{
                  padding: "10px 20px",
                  backgroundColor: "rgb(31, 58, 112)",
                  color: "#fff",
                  border: "none",
                  borderRadius: 12,
                  cursor: loading ? "not-allowed" : "pointer",
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  opacity: loading ? 0.8 : 1,
                }}
                aria-busy={loading}
                >
                {loading ? <div className="spinner"></div> : "Criar Grupo"}
                </button>
                </>
            </div>
              

            <h4 style={{ width: "100%", marginTop: 16, marginBottom: 8, fontSize: 16, color: "#333", textAlign: "left" }}>
                Participantes
            </h4>


            <div style={styles.participantsList}>
                {selectedParticipants.map((p) => {
                   
                 return (
                    <div key={p.STAMP || p.NOME} style={styles.participant}>
                        <div style={styles.participantIcon}>
                        <div
                            style={{
                            width: 30,
                            height: 30,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            borderRadius: "50%",
                            }}
                        >


                        {p.FOTO && (
                            <img
                            src={p.FOTO}
                            alt={p.NOME}
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                            }}
                            onError={(event) => {
                              event.currentTarget.style.display = "none";
                              event.currentTarget.nextElementSibling.style.display = "flex";
                            }}
                            />
                        )}
                        <span
                          style={{
                            width: "100%",
                            height: "100%",
                            display: p.FOTO ? "none" : "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          {p.TIPO === "TM" ? (
                            <FaUserShield size={20} color="#6b7280" />
                          ) : (
                            <FaUser size={20} color="#6b7280" />
                          )}
                        </span>
                    
                        </div>
                    </div>    
                        <span style={styles.participantName}>{formatFirstLastName(p.NOME)}</span>
                    </div>
                    );
                })}
            </div>


        </div>   


          
        </div>
      )}
    </div>
  );
}